// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-inner-declarations */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable camelcase */
const originalDynamicLinkNavigation = dynamicLinkNavigation;

dynamicLinkNavigation = function(url) {
    console.log("🚀 dynamicLinkNavigation called with URL:", url);
    originalDynamicLinkNavigation(url);
};

try {
	async function fetchData(oemId, oemKey) {
		// 2) Check if statesSupportedAbbrevs has already been fetched and set
		// console.log('window.statesSupportedAbbrevs:', window.statesSupportedAbbrevs);
		if (window.statesSupportedAbbrevs) {
			return window.statesSupportedAbbrevs;
		}
		try {
			const response = await fetch(
				`${window.ekhoFuncHost}/oem_onfetch_v2/statesSupported/${oemId}?oemKey=${oemKey}`,
			);
			const data = await response.json();
			const { statesSupportedAbbrevs } = data;
			if (statesSupportedAbbrevs) {
				window.statesSupportedAbbrevs = statesSupportedAbbrevs;
				return statesSupportedAbbrevs;
			}
			throw new Error('No states supported found');
		} catch (error) {
			console.error('An error occurred while fetching states supported:', error);
			return [];
		}
	}
	async function ekhoCheckoutSubmitOrderFunction(allStatesLive) {
		function setButtonLoading() {
			const button = document.getElementById('ekho-land-checkout-button');
			const loadingButton = document.getElementById('ekho-land-checkout-button-loading');
			button.style.display = 'none';
			loadingButton.style.display = 'block';
			const ekhoLandErrorMessage = document.getElementById('ekhoLandErrorMessage');
			ekhoLandErrorMessage.style.display = 'none';
		}
		function setNormalButton() {
			const button = document.getElementById('ekho-land-checkout-button');
			const loadingButton = document.getElementById('ekho-land-checkout-button-loading');
			button.style.display = 'flex';
			loadingButton.style.display = 'none';
		}
		function setErrorMessage(errorMessage) {
			const ekhoLandErrorMessage = document.getElementById('ekhoLandErrorMessage');
			ekhoLandErrorMessage.style.display = 'block';
			ekhoLandErrorMessage.textContent = errorMessage;
			setTimeout(() => {
				ekhoLandErrorMessage.style.display = 'none';
			}, 3000);
		}
		// Add the .ekho-checkout-button-disabled class to the checkout button below
		setButtonLoading();
		let registrationState = null;
		// ensure state has been selected if allStatesLive is false
		if (!allStatesLive) {
			const customSelectElement = document.getElementById('ekhoDealerStateSelect');
			if (customSelectElement) {
				registrationState = customSelectElement.getAttribute('data-value');
			}
			const button = document.getElementById('ekho-land-checkout-button');
			if (!registrationState || !button) {
				setErrorMessage('Please select a state before checking out.');
				setNormalButton();
				return;
			}
		}
		let shopifyCartItems = [];
		try {
			const response = await fetch('/cart.js');
			if (!response.ok) {
				throw new Error(`Failed to fetch Shopify cart: ${response.status}`);
			}
			const cartData = await response.json();
			shopifyCartItems = cartData.items.map((item) => {
				// Transform options_with_values into the specs array
				const specs = item.options_with_values.map((option) => ({
					name: option.name,
					price: 0,
					option: option.value,
				}));
				return {
					productId: item.product_id?.toString(),
					variantId: item.variant_id?.toString(),
					basePrice: Number(item.final_price) / 100,
					specs,
					name: item.product_title,
					imgUrl: item.image,
					count: item.quantity ? Number(item.quantity) : 1,
				};
			});
		} catch (error) {
			setErrorMessage('An error with Shopify occurred. Please reload the page and try again');
			setNormalButton();
		}
		const url = `${window.ekhoFuncHost}/checkoutCart_oncreate_v2`;
		const requestBody = {
			registrationState,
			cancelUrl: window.location.href,
			items: shopifyCartItems,
			nativeDefaultCheckoutUrl: window.location.href,
			ecommUserId: null,
			oemKey: window.ekhoOemKey,
		};

		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(requestBody),
			});
			if (!response.ok) {
				throw new Error(`Server responded with status ${response.status}`);
			}
			const data = await response.json();
			const { ekhoCheckoutCartId } = data;
			if (ekhoCheckoutCartId) {
              
				
				if (window.ekhoBaseUrl) {
					const newPath = `https://checkout.landmoto.io/checkout?&cartId=${ekhoCheckoutCartId}`;
					// eslint-disable-next-line no-undef
					dynamicLinkNavigation(newPath);
                  console.log("✅ execution of ekhoCheckoutCartId 1st condition ", newPath);
				} else {
					const newPath = `https://checkout.landmoto.io/checkout?&cartId=${ekhoCheckoutCartId}`;
					// eslint-disable-next-line no-undef
					dynamicLinkNavigation(newPath);
                  console.log("✅ execution of ekhoCheckoutCartId 2nd condition", newPath);
				}
			} else {
				// Take the buyer to the Shopify checkout page (which is /checkout)
				window.location.href = '/checkout';
              console.log("✅ execution of ekhoCheckoutCartId");
			}
		} catch (error) {
			console.error('Error creating checkout session:', error.message);
			setErrorMessage(
				'An error occurred while creating your checkout session. Please reload the page and try again or contact support.',
			);
			setNormalButton();
		}
	}
	async function runOnLoad() {
		// The DOMContentLoaded event already fired
		// TO DISABLE EKHO SET BELOW TO true
		const disabled = false;
		// TO TURN ON ALL STATES SET BELOW TO true
		const allStatesLive = true;
		// const isFireFox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
		const isFireFox = false;
		const isEkhoDisabled = isFireFox || disabled;
		// run the below code only if the script has not been loaded
		if (
			!window.ekhoStateScriptLoaded ||
			window.isEkhoDisabled === undefined ||
			window.allStatesLive === undefined
		) {
			const currEnv = 'production';
			// Set the scriptLoaded flag to true
			window.ekhoStateScriptLoaded = true;
			// Set window variables based on the config above
			window.isEkhoDisabled = isEkhoDisabled;
			window.allStatesLive = allStatesLive;
			switch (currEnv) {
				case 'development':
					window.ekhoOemKey = 'land-dev-oem';
					window.ekhoOemId = 'land-dev-oem-id';
					window.ekhoFuncHost = 'https://us-central1-airdealer-67669.cloudfunctions.net';
					window.ekhoBaseUrl = 'http://localhost:3000';
					break;
				case 'staging':
					window.ekhoOemKey = 'land';
					window.ekhoOemId = 'Dw11Hij5QzzTenm6Odbf';
					window.ekhoFuncHost = 'https://us-central1-ed-staging.cloudfunctions.net';
					window.ekhoBaseUrl = `https://${window.ekhoOemKey}-checkout.ekhodealer.com`;
					break;
				case 'production':
					window.ekhoOemKey = 'land';
					window.ekhoOemId = 'Dw11Hij5QzzTenm6Odbf';
					window.ekhoFuncHost = 'https://us-central1-ad-backend-prod.cloudfunctions.net';
					window.ekhoBaseUrl = `https://${window.ekhoOemKey}-checkout.ekhodealer.com`;
					break;
				default:
					window.ekhoOemKey = 'land';
					window.ekhoOemId = 'Dw11Hij5QzzTenm6Odbf';
					window.ekhoFuncHost = 'https://us-central1-ad-backend-prod.cloudfunctions.net';
					window.ekhoBaseUrl = `https://${window.ekhoOemKey}-checkout.ekhodealer.com`;
					break;
			}
			document.addEventListener('click', (event) => {
                  // If clicked on id="ekho-financing-copy", redirect to /checkout/
                  if (event.target.closest('#ekho-land-checkout-button')) {
                      console.log("🚀 Click on #ekho-land-checkout-button, redirecting to /checkout/");
                      window.location.href = '/checkout';
                  } 
                  // If any element with class .link-ekho is clicked, execute ekhoCheckoutSubmitOrderFunction
                  else if (event.target.closest('.link-ekho')) {
                      console.log("🚀 Click on .link-ekho, executing ekhoCheckoutSubmitOrderFunction");
                      ekhoCheckoutSubmitOrderFunction(window.allStatesLive);
                  }
              });

			const defaultFinancingCopyHtml = `<h5><strong>Great Credit? Vehicle Financing through EKHO</strong></h5><p class="link-ekho">Go to Ekho</p><br><h5><strong>For Affirm and other options click checkout below</strong></h5>`;
			const ekhoCheckoutFinancingCopyHtml = `<h5><strong>Great Credit? Vehicle Financing through EKHO</strong></h5><h5 class="link-ekho" style="cursor:pointer; text-decoration:underline">Go to Ekho</h5><br><h5><strong>For Affirm and other options click checkout below</strong></h5>`;
			// const ekhoHomePageFinancingCopyHtml = `<p class="bike-thumbs__subheading">As low as $120 / 84 mo - with Ekho</p><p class="bike-thumbs__subheading">As low as $125 / 60 mo - with Octane</p><p class="bike-thumbs__subheading">As low as $312 / 24 mo - with Affirm</p>`;
			function injectEkhoCheckoutFinancingCopy() {
				// Append a div to the cart-drawer__message div with the id of ekho-financing-copy and include copy
				const cartDrawerMessage = document.querySelector('.cart-drawer__message');
				const ekhoFinancingCopyOld = document.getElementById('ekho-financing-copy');
				// Only inject if it doesn't already exist
				if (cartDrawerMessage && !ekhoFinancingCopyOld) {
					// hide cartDrawerMessage
					cartDrawerMessage.classList?.add('original-message');
					cartDrawerMessage.style.display = 'none';
					const ekhoFinancingCopy = document.createElement('div');
					// add a class
					ekhoFinancingCopy.classList?.add('cart-drawer__message');
					// ekhoFinancingCopy.classList.add('ekho-financing-copy');
					ekhoFinancingCopy.id = 'ekho-financing-copy';
					ekhoFinancingCopy.innerHTML = defaultFinancingCopyHtml;
					// Use insertAdjacentElement to place the new div after the cartDrawerMessage div
					cartDrawerMessage.insertAdjacentElement('afterend', ekhoFinancingCopy);
					if (window.allStatesLive) {
						handleAllStatesLive();
					}
				}
				// // Now deal with the financing copy on the home page
				// const thumbHeaderMessage = document.querySelector('.bike-thumbs__head');
				// const ekhoHomePageFinancingCopyOld = document.getElementById(
				// 	'ekho-home-financing-copy',
				// );
				// if (thumbHeaderMessage && !ekhoHomePageFinancingCopyOld) {
				// 	console.log('thumbHeaderMessage:', thumbHeaderMessage);
				// 	// hide thumbHeaderMessage
				// 	thumbHeaderMessage.classList.add('original-message');
				// 	thumbHeaderMessage.style.display = 'none';
				// 	const ekhoHomePageFinancingCopy = document.createElement('div');
				// 	// add a class
				// 	ekhoHomePageFinancingCopy.classList.add('bike-thumbs__head');
				// 	ekhoHomePageFinancingCopy.id = 'ekho-home-financing-copy';
				// 	ekhoHomePageFinancingCopy.innerHTML = ekhoHomePageFinancingCopyHtml;
				// 	// Use insertAdjacentElement to place the new div after the cartDrawerMessage div
				// 	thumbHeaderMessage.insertAdjacentElement('afterend', ekhoHomePageFinancingCopy);
				// }
				// handle disabled user
				if (window.isEkhoDisabled) {
					handleEkhoDisabled();
				}
			}
			function handleStateSupported() {
				// console.log('handleStateSupported called');
				const buttonContainer = document.querySelector('#ekho-land-checkout-button');
				if (buttonContainer) {
					buttonContainer.style.display = 'flex';
				}

				const checkoutDisclaimer = document.querySelector('#ekho-land-checkout-disclaimer');
				if (checkoutDisclaimer) {
					checkoutDisclaimer.style.display = 'block';
				}

				const landButton = document.querySelector('#land-checkout-drawer-button');
				if (landButton) {
					landButton.style.display = 'none';
				}
				const landButton2 = document.querySelector('#land-checkout-button');
				if (landButton2) {
					landButton2.style.display = 'none';
				}
				// Find the cart-drawer__message div and set display to block
				const cartDrawerMessage = document.querySelector(
					'.cart-drawer__message.original-message',
				);
				if (cartDrawerMessage) {
					cartDrawerMessage.style.display = 'none';
				}
				// Find the ekho-financing-copy div and set display to block
				const ekhoFinancingCopy = document.querySelector('#ekho-financing-copy');
				if (ekhoFinancingCopy) {
					ekhoFinancingCopy.style.display = 'block';
					// set the innerHTML to the new copy
					ekhoFinancingCopy.innerHTML = ekhoCheckoutFinancingCopyHtml;
				}
			}
			function handleStateNotSupported() {
				const buttonContainer = document.querySelector('#ekho-land-checkout-button');
				if (buttonContainer) {
					buttonContainer.style.display = 'none';
				}

				const checkoutDisclaimer = document.querySelector('#ekho-land-checkout-disclaimer');
				if (checkoutDisclaimer) {
					checkoutDisclaimer.style.display = 'none';
				}
				const landButton = document.querySelector('#land-checkout-drawer-button');
				if (landButton) {
					landButton.style.display = 'block';
				}
				const landButton2 = document.querySelector('#land-checkout-button');
				if (landButton2) {
					landButton2.style.display = 'block';
				}
				// Find the cart-drawer__message div and set display to block
				const cartDrawerMessage = document.querySelector(
					'.cart-drawer__message.original-message',
				);
				if (cartDrawerMessage) {
					cartDrawerMessage.style.display = 'block';
				}
				// Find the ekho-financing-copy div and set display to block
				const ekhoFinancingCopy = document.querySelector('#ekho-financing-copy');
				if (ekhoFinancingCopy) {
					ekhoFinancingCopy.style.display = 'none';
				}
			}
			function handleStateNotSelected() {
				const buttonContainer = document.querySelector('#ekho-land-checkout-button');
				if (buttonContainer) {
					buttonContainer.style.display = 'flex';
				}

				const checkoutDisclaimer = document.querySelector('#ekho-land-checkout-disclaimer');
				if (checkoutDisclaimer) {
					checkoutDisclaimer.style.display = 'none';
				}
				const landButton = document.querySelector('#land-checkout-drawer-button');
				if (landButton) {
					landButton.style.display = 'none';
				}
				const landButton2 = document.querySelector('#land-checkout-button');
				if (landButton2) {
					landButton2.style.display = 'none';
				}
				// Find the cart-drawer__message div and set display to block
				const cartDrawerMessage = document.querySelector(
					'.cart-drawer__message.original-message',
				);
				if (cartDrawerMessage) {
					cartDrawerMessage.style.display = 'none';
				}
				// Find the ekho-financing-copy div and set display to block
				const ekhoFinancingCopy = document.querySelector('#ekho-financing-copy');
				if (ekhoFinancingCopy) {
					ekhoFinancingCopy.style.display = 'block';
					// set the innerHTML to the new copy
					ekhoFinancingCopy.innerHTML = defaultFinancingCopyHtml;
				}
			}
			function handleEkhoDisabled() {
				// do the same steps done when state not supported.
				handleStateNotSupported();
				// and then hide the state select element
				const ekhoStateSelectContainer = document.querySelector(
					'#ekho-land-select-container',
				);
				if (ekhoStateSelectContainer) {
					ekhoStateSelectContainer.style.display = 'none';
				}
			}
			function handleAllStatesLive() {
				// do the same steps done when state is supported.
				handleStateSupported();
				// hide the state select element
				const ekhoStateSelectContainer = document.querySelector(
					'#ekho-land-select-container',
				);
				if (ekhoStateSelectContainer) {
					ekhoStateSelectContainer.style.display = 'none';
				}
			}
			// Create a MutationObserver to listen for changes in the DOM
			const observer = new MutationObserver(() => injectEkhoCheckoutFinancingCopy());
			// Start observing the body for added nodes
			observer.observe(document.body, { childList: true, subtree: true });

			// check if ekho is disabled
			if (window.isEkhoDisabled || window.allStatesLive) {
				// do nothing
			} else {
				fetchData(window.ekhoOemId, window.ekhoOemKey).then((statesSupportedAbbrevs) => {
					// console.log('statesSupportedAbbrevs:', statesSupportedAbbrevs);
					window.ekhoStateListenerAdded = true;
					document.addEventListener('change', (event) => {
						// Check if the changed element is ekhoStateSelect element
						if (event.target.closest('#ekhoDealerStateSelect')) {
							// get the value from the select field
							const fieldValue = event.target.getAttribute('data-value');
							// get the element (name it field)
							const field = document.querySelector('#ekhoDealerStateSelect');
							if (!fieldValue || fieldValue === '') {
								// STATE IS NOT SELECTED
								handleStateNotSelected();
								field.classList?.remove('ekhoDealerStateSelectGreenOutline');
								field.classList?.add('ekhoDealerStateSelectRedOutline');
							} else if (statesSupportedAbbrevs.includes(fieldValue)) {
								// STATE IS SUPPORTED
								handleStateSupported();
								field.classList?.remove('ekhoDealerStateSelectRedOutline');
								field.classList?.add('ekhoDealerStateSelectGreenOutline');
							} else {
								// STATE IS NOT SUPPORTED
								handleStateNotSupported();
								field.classList?.remove('ekhoDealerStateSelectRedOutline');
								field.classList?.add('ekhoDealerStateSelectGreenOutline');
							}
						}
					});
					function simulateChangeEvent(selectedValue) {
						// console.log('simulateChangeEvent called with:', selectedValue);
						// console.log('statesSupportedAbbrevs:', statesSupportedAbbrevs);
						// console.log(
						// 	'statesSupportedAbbrevs.includes(selectedValue):',
						// 	statesSupportedAbbrevs.includes(selectedValue),
						// );
						// Assuming statesSupportedAbbrevs is defined and accessible
						const field = document.querySelector('.ekhoDealerStateSelect');

						if (!selectedValue || selectedValue === '') {
							handleStateNotSelected();
							field.classList.remove('ekhoDealerStateSelectGreenOutline');
							field.classList.add('ekhoDealerStateSelectRedOutline');
						} else if (statesSupportedAbbrevs.includes(selectedValue)) {
							handleStateSupported();
							field.classList.remove('ekhoDealerStateSelectRedOutline');
							field.classList.add('ekhoDealerStateSelectGreenOutline');
						} else {
							handleStateNotSupported();
							field.classList.remove('ekhoDealerStateSelectRedOutline');
							field.classList.add('ekhoDealerStateSelectGreenOutline');
						}
					}

					// Assuming the selectOption function looks something like this:
					function selectOption(event) {
						const value = event.target.getAttribute('data-value');
						const displayText = event.target.innerText;
						const select = document.querySelector('.ekhoDealerStateSelect');
						select.setAttribute('data-value', value);
						select.childNodes[0].nodeValue = displayText; // Update the display text
						// Call the simulateChangeEvent function with the selected value
						simulateChangeEvent(value);
						closeDropdown(); // Close the dropdown
					}

					// And the closeDropdown function to hide the options container
					function closeDropdown() {
						const optionsContainer = document.querySelector(
							'.ekhoDealerStateSelect .ekho-options-container',
						);
						if (optionsContainer) {
							optionsContainer.style.display = 'none';
						}
					}

					document.addEventListener(
						'click',
						function (event) {
							// Reference to the custom select and its options
							const customSelect = document.querySelector('.ekhoDealerStateSelect');
							const optionsContainer =
								customSelect?.querySelector('.ekho-options-container');
							const isCustomSelect = customSelect?.contains(event.target);
							const isOption = event.target.classList.contains('ekho-option');

							// Logic to toggle the dropdown if the custom select itself is clicked
							if (isCustomSelect && !isOption) {
								// Prevent the default action and stop propagation
								event.preventDefault();
								event.stopPropagation();
								// Toggle the dropdown visibility
								optionsContainer.style.display =
									optionsContainer.style.display === 'block' ? 'none' : 'block';
							} else if (isOption) {
								// Assuming selectOption is defined to handle option selection
								selectOption(event);
								event.preventDefault(); // Prevent default action when an option is selected
							} else {
								closeDropdown();
							}
						},
						true,
					);

					// Attach the event listener to the custom select element
					document.addEventListener('keydown', (event) => {
						if (event.target.id === 'ekhoDealerStateSelect') {
							handleKeyPress(event);
						}
					});

					function handleKeyPress(event) {
						// Ignore non-alphabetical keys
						if (!event.key.match(/^[a-z]$/i)) return;

						// Get the pressed key and convert it to lowercase
						const pressedKey = event.key.toLowerCase();

						// Find the first option that starts with the pressed key
						const optionsContainer = document.getElementById('ekho-options-container');
						const matchingOption = Array.from(optionsContainer.children).find(
							(option) => option.textContent.toLowerCase().startsWith(pressedKey),
						);
						// If a matching option is found, update the select display and value
						if (matchingOption) {
							// Optionally, ensure the matched option is visible in the dropdown
							matchingOption.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
						}
					}
				});
			}

			// document.addEventListener(
			// 	'focus',
			// 	function (event) {
			// 		console.log('FOCUSING on: ', event.target);
			// 		const { target } = event;
			// 		const isPopUp = target.classList?.contains('mfp-wrap');
			// 		const isStateSelect = target.id === 'ekhoDealerStateSelect';
			// 		console.log('isStateSelect', isStateSelect);
			// 		console.log('isPopup', isPopUp);
			// 		// if (isPopUp || isStateSelect) {
			// 		// 	console.log('Stop focus move to popup or state select');
			// 		// 	// Prevent default focus behavior if it's trying to move to the state select element
			// 		// 	// while the select element is active
			// 		// 	event.preventDefault();
			// 		// 	event.stopPropagation();
			// 		// }
			// 	},
			// 	true,
			// ); // Using true to capture the event during the capturing phase

			// document.addEventListener(
			// 	'blur',
			// 	function (event) {
			// 		console.log('BLUR on: ', event.target);
			// 		if (event.target.id === 'ekhoDealerStateSelect') {
			// 			console.log('Select lost focus to:', document.activeElement);
			// 		}
			// 	},
			// 	true,
			// ); // Using true to capture the event during the capturing phase
		}
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', runOnLoad);
	} else {
		runOnLoad();
	}
} catch (error) {
	console.error('Error in landLoadStates.js:', error);
}
